export function createFukushizaiCopyContentService(deps) {
    // 副資材 BASE 複写時に対象とする内容列一覧を返します。
    function getFukushizaiBaseCopyContentColumnIds() {
        const excluded = new Set([
            deps.ROW_ID_FIELD,
            deps.FUKUSHIZAI_FIELD.NO,
            deps.FUKUSHIZAI_FIELD.ITEM_CD,
            deps.FUKUSHIZAI_FIELD.GROUP_NO,
            deps.FUKUSHIZAI_FIELD.COLOR_CD,
            "INDEX",
            "GRIP",
            "EXPAND",
            "ROW_KIND"
        ].map((fieldId) => String(fieldId ?? "").trim().toUpperCase()));

        return [...deps.getFukushizaiSsdzSaveColumnIdSet()]
            .map((fieldId) => String(fieldId ?? "").trim())
            .filter((fieldId) => {
                const cid = fieldId.toUpperCase();
                return cid !== ""
                    && !excluded.has(cid)
                    && !deps.isKakousijiSavePayloadUiOnlyField(fieldId, deps.FUKUSHIZAI_BASE_PANEL_TYPE);
            });
    }

    // 副資材の内容列を source から target へ複写します。
    function copyFukushizaiContentColumns(targetRow, sourceRow, contentColumnIds, panelType = "") {
        const clearFukushizaiDisplayProjectionFields = deps.clearFukushizaiDisplayProjectionFields();
        const extractMasterCodeFromDisplayValue = deps.extractMasterCodeFromDisplayValue();
        const next = clearFukushizaiDisplayProjectionFields({ ...(targetRow || {}) });

        (Array.isArray(contentColumnIds) ? contentColumnIds : []).forEach((columnId) => {
            const cid = String(columnId ?? "").trim();
            // 空の列 ID は処理対象外です。
            if (cid === "") return;

            const value = deps.readRowValueIgnoreCase(sourceRow, cid);
            next[cid] = value === undefined ? "" : value;

            // 縦持ちマスタ列は code 差し替えに応じて名称系フィールドもクリアします。
            if (deps.isFukushizaiVerticalMasterSourceColumnId(cid)) {
                deps.clearFukushizaiMasterNameFields(next, cid, {
                    timing: "group-copy",
                    panelType,
                    oldCode: extractMasterCodeFromDisplayValue(deps.DicVal(targetRow, cid, "")),
                    newCode: extractMasterCodeFromDisplayValue(next[cid]),
                    reason: "copy-content-column"
                });
            }
        });

        return next;
    }

    return {
        getFukushizaiBaseCopyContentColumnIds,
        copyFukushizaiContentColumns
    };
}
